import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

class SummaryAnalytics extends BaseAnalytics {
    constructor(category: string) {
        super();
        this.category = category;
    }

    clickOpenBottomStickySummary() {
        this.send('click check payment', 'click');
    }

    promocodeStartedTyping() {
        this.send('promocode_start_enter');
    }

    clickViewConnectionCostPopup() {
        this.send('connection_cost_popup', 'view_popup');
    }

    promocodeSuccessVerification(promocode: string | undefined) {
        this.send('promocode_verification', `success | ${promocode}`);
    }

    promocodeFailVerification(promocode: string) {
        this.send('promocode_verification', `error | ${promocode}`);
    }

    promocodeClickedOnHave() {
        this.send('promocode_click_have');
    }

    promocodeClickVerification() {
        this.send('promocode_click_verification');
    }
}

export default SummaryAnalytics;
